import React from 'react';
import { FeatureFlagProvider } from '@/context/FeatureFlagContext.jsx';
import { LoginDrawerProvider } from '@/context/LoginDrawerContext.jsx';
import { DynamicPanelProvider } from '@/context/DynamicPanelContext.jsx';
import { CommunityIdentityProvider } from '@/context/CommunityIdentityContext.jsx';

function AppProviders({ children }) {
    return (
        <LoginDrawerProvider>
            <FeatureFlagProvider>
                <DynamicPanelProvider>
                    <CommunityIdentityProvider>{children}</CommunityIdentityProvider>
                </DynamicPanelProvider>
            </FeatureFlagProvider>
        </LoginDrawerProvider>
    );
}

export default AppProviders;
